// Utils & Config
import AxiosService from '../utils/AxiosService';
import Config from '../config';

export interface UnlockChallengesInterface {
    userIds: string[]
}

export interface UnlockGroupChallengesInterface {
    groupIds: string[]
}

const forceUnlockChallenges = async (payload: UnlockChallengesInterface) => await AxiosService.post(Config.server.api.progressApi + 'pro/unlock', payload, true);
const forceUnlockGroupChallenges = async (payload: UnlockGroupChallengesInterface) => await AxiosService.post(Config.server.api.progressApi + 'pro/unlock/groups', payload, true);

const exports = {
    forceUnlockChallenges,
    forceUnlockGroupChallenges
};
export default exports;